var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "93c52004db871dcc453b0d388aea92e5.png",
    width: 222,
    height: 210
});